import { DashboardLayout } from '@/layout/DashboardLayout';
import { TwoFactorSection } from './components/TwoFactorSection';

export function SecurityPage() {
  return (
    <DashboardLayout title="Segurança">
      <TwoFactorSection />
    </DashboardLayout>
  );
}
